import { Stack } from '@understory-io/leaf/stack';
import { Text } from '@understory-io/leaf/text';
import { css } from '@understory-io/leaf/css';
import { FormattedMessage } from 'react-intl';

/**
 * Shown in the booking widget when the host is not ready to receive payments
 * (no payment method configured for a paid, non-shared experience). Replaces
 * the calendar/list + CTA, mirroring the legacy "Try again later" state.
 */
export function PaymentsNotReadyState() {
  return (
    <Stack gap="xsmall" align="center" className={containerStyle}>
      <Text style="subheadline-small" as="h2">
        <FormattedMessage
          defaultMessage="Try again later"
          description="Booking widget heading when the host is not ready to receive payments"
        />
      </Text>
      <Text style="body-small-regular" color="secondary">
        <FormattedMessage
          defaultMessage="We are unfortunately not quite ready to receive bookings yet, but we are working on it."
          description="Booking widget body shown when the host has not set up a payment provider"
        />
      </Text>
    </Stack>
  );
}

const containerStyle = css({
  padding: 'large',
  borderRadius: 'large',
  background: 'surface.raised',
  textAlign: 'center',
});
